export default __webpack_public_path__ + "locales/fr/UploadPanel.json?hash=3201b8098c21015d0243abd2075fe83d";